module.exports = __webpack_public_path__ + "img/Weapon_294.8118a02c.png";